// Job Application Form
// --------------------
(function ($) {

    $.fn.jobApplicationForm = function () {
        return this.each(function () {
            const $form = $(this),
                $fileField = $form.find('input[type="file"]'),
                $span = $fileField.next('span'),
                $clear = $form.find('a.clear'),
                $label = $form.find('label');
            $label.addClass('no-file');

            $clear.bind('click', function (evt) {
                $fileField.val('').trigger('change');
                evt.preventDefault();
            });

            $fileField.bind('change', function () {
                const filename = $(this).val().split(/[\\\/]/ig).pop();
                $span.html(filename);
                $clear.toggleClass('hide', (filename === ''));
                $label.toggleClass('no-file', (filename === ''));
            });
        });
    };

    $(function () {
        $('#job-application-form').jobApplicationForm();
    });
})(jQuery);
